import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Córdoba'
}, {
  name: 'Julián L.',
  location: 'Buenos Aires'
}, {
  name: 'Carolina P.',
  location: 'La Plata'
}, {
  name: 'Ricardo A.',
  location: 'Mendoza'
}, {
  name: 'Florencia B.',
  location: 'Rosario'
}, {
  name: 'Agustina S.',
  location: 'CABA'
}];
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const buyer = buyers[buyerIndex];
  useEffect(() => {
    const openTimer = window.setTimeout(() => setIsVisible(true), 4500);
    const interval = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setBuyerIndex(current => (current + 1) % buyers.length);
        setIsVisible(true);
      }, 800);
    }, 30000);
    return () => {
      window.clearTimeout(openTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-72" data-mp="1qxxjtzq6pv8j">
      {isVisible && <motion.aside initial={reduceMotion ? false : {
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? undefined : {
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] md:bottom-7 md:left-7" data-id="element-73" data-mp="1qwmh838h6tj0">
          <div className="glass-panel flex gap-3 rounded-2xl border-brand-forest/25 bg-brand-paper/95 p-4 shadow-xl" data-id="element-74" data-mp="u7euirw4eedi">
            <span className="mt-0.5 rounded-full bg-brand-greenSage p-2" data-id="element-75" data-mp="kj9kh0fo7v48">
              <BadgeCheckIcon className="h-5 w-5 text-brand-forest" data-id="element-76" data-mp="om5yedu9n31u" />
            </span>
            <div data-id="element-77" data-mp="am4wqw66frlb">
              <p className="text-xs text-brand-muted" data-id="element-78" data-mp="amohekn7ou31">
                Compra verificada · hace unos minutos
              </p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-79" data-mp="flhsk6f10901">
                <strong data-id="element-80" data-mp="13a0rvwg3lbfz">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="mt-1 text-sm font-bold text-brand-forest" data-id="element-81" data-mp="189dmx4h4hotn">
                El Botiquín Ancestral™
              </p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}